import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonCard, IonCardContent, IonCol, IonGrid, IonIcon, IonRow, IonText } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { IDecaDocument, UUID } from '@okcargo-apps/shared-domain';
import { DateFnsModule } from 'ngx-date-fns';

@Component({
  selector: 'lib-deca-list-item',
  templateUrl: './deca-list-item.component.html',
  styleUrls: ['./deca-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonText,
    IonIcon,
    IonCard,
    IonCardContent,
    IonGrid,
    IonRow,
    IonCol,
    RouterLink,
    RouterLinkActive,
    DateFnsModule,
    TranslateModule,
  ],
})
export class DecaListItemComponent {
  public readonly document = input.required<IDecaDocument>();
  public readonly userCompanyId = input.required<UUID>();
  public readonly detailRoute = input<string>('');

  protected readonly isCarrier = computed(() => this.document().carrier.id === this.userCompanyId());
  protected readonly isShipper = computed(() => this.document().shipper.id === this.userCompanyId());

  protected readonly isInvalid = computed(() => {
    const doc = this.document();
    if (!doc.carrier.contactEmail) return true;
    if (doc.segments?.some((seg) => !seg.netWeight) || !doc.tractorPlateNumber) return true;
    return false;
  });
}
